/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListModelPaintsParams,
  ModelPaint,
  ModelPaintInput,
  ModelPaints,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create Model Paint
 */
export const createModelPaint = (
    modelPaintInput: MaybeRefOrGetter<ModelPaintInput>,
 signal?: AbortSignal
) => {
      modelPaintInput = toValue(modelPaintInput);

      return axiosClient<ModelPaint>(
      {url: `/model-paints`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modelPaintInput, signal
    },
      );
    }




export const getCreateModelPaintMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelPaint>>, TError,CreateModelPaintMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createModelPaint>>, TError,CreateModelPaintMutationVariables, TContext> => {

const mutationKey = ['createModelPaint'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createModelPaint>>, CreateModelPaintMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createModelPaint(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateModelPaintMutationResult = NonNullable<Awaited<ReturnType<typeof createModelPaint>>>
    export type CreateModelPaintMutationBody = ModelPaintInput
    export type CreateModelPaintMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CreateModelPaintMutationVariables = {data: ModelPaintInput}

    /**
 * @summary Create Model Paint
 */
export const useCreateModelPaint = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelPaint>>, TError,CreateModelPaintMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createModelPaint>>,
        TError,
        CreateModelPaintMutationVariables,
        TContext
      > => {
      return useMutation(getCreateModelPaintMutationOptions(options), queryClient);
    }
    /**
 * @summary Paints list
 */
export const listModelPaints = (
    params?: MaybeRefOrGetter<ListModelPaintsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<ModelPaints>(
      {url: `/model-paints`, method: 'GET',
        params, signal
    },
      );
    }




export const getListModelPaintsQueryKey = (params?: MaybeRefOrGetter<ListModelPaintsParams>,) => {
    return [
    'model-paints', ...(params ? [params] : [])
    ] as const;
    }


export const getListModelPaintsQueryOptions = <TData = Awaited<ReturnType<typeof listModelPaints>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ListModelPaintsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listModelPaints>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListModelPaintsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listModelPaints>>> = ({ signal }) => listModelPaints(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listModelPaints>>, TError, TData>
}

export type ListModelPaintsQueryResult = NonNullable<Awaited<ReturnType<typeof listModelPaints>>>
export type ListModelPaintsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Paints list
 */

export function useListModelPaints<TData = Awaited<ReturnType<typeof listModelPaints>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ListModelPaintsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listModelPaints>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListModelPaintsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy Model Paint
 */
export const destroyModelPaint = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ModelPaint>(
      {url: `/model-paints/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyModelPaintMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModelPaint>>, TError,DestroyModelPaintMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyModelPaint>>, TError,DestroyModelPaintMutationVariables, TContext> => {

const mutationKey = ['destroyModelPaint'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyModelPaint>>, DestroyModelPaintMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyModelPaint(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyModelPaintMutationResult = NonNullable<Awaited<ReturnType<typeof destroyModelPaint>>>

    export type DestroyModelPaintMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyModelPaintMutationVariables = {id: string}

    /**
 * @summary Destroy Model Paint
 */
export const useDestroyModelPaint = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModelPaint>>, TError,DestroyModelPaintMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyModelPaint>>,
        TError,
        DestroyModelPaintMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyModelPaintMutationOptions(options), queryClient);
    }
    /**
 * @summary Model Paint Detail
 */
export const modelPaint = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ModelPaint>(
      {url: `/model-paints/${id}`, method: 'GET', signal
    },
      );
    }




export const getModelPaintQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'model-paints',id
    ] as const;
    }


export const getModelPaintQueryOptions = <TData = Awaited<ReturnType<typeof modelPaint>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelPaint>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelPaintQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelPaint>>> = ({ signal }) => modelPaint(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelPaint>>, TError, TData>
}

export type ModelPaintQueryResult = NonNullable<Awaited<ReturnType<typeof modelPaint>>>
export type ModelPaintQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Paint Detail
 */

export function useModelPaint<TData = Awaited<ReturnType<typeof modelPaint>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelPaint>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelPaintQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Model Paint
 */
export const updateModelPaint = (
    id: MaybeRefOrGetter<string>,
    modelPaintInput: MaybeRefOrGetter<ModelPaintInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
modelPaintInput = toValue(modelPaintInput);

      return axiosClient<ModelPaint>(
      {url: `/model-paints/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: modelPaintInput, signal
    },
      );
    }




export const getUpdateModelPaintMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelPaint>>, TError,UpdateModelPaintMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateModelPaint>>, TError,UpdateModelPaintMutationVariables, TContext> => {

const mutationKey = ['updateModelPaint'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateModelPaint>>, UpdateModelPaintMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateModelPaint(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateModelPaintMutationResult = NonNullable<Awaited<ReturnType<typeof updateModelPaint>>>
    export type UpdateModelPaintMutationBody = ModelPaintInput
    export type UpdateModelPaintMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateModelPaintMutationVariables = {id: string;data: ModelPaintInput}

    /**
 * @summary Update Model Paint
 */
export const useUpdateModelPaint = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelPaint>>, TError,UpdateModelPaintMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateModelPaint>>,
        TError,
        UpdateModelPaintMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateModelPaintMutationOptions(options), queryClient);
    }
